<template >
<div class="container-fluid">


    <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />

     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>


  <div class="col-auto">

  
  <div class="card border-info ">
    <div style="background-color:#0066FF" class="card-header bg-info text-white">
      <h4><i class="fas fa-binoculars mr-3" aria-hidden="true"></i>RICERCA COUPON</h4>
    </div>  
  <div class="card-body">   


  <form v-on:submit.prevent="submit()">
  <div class="form-group col-md-6">
    <label for="formGroupExampleInput4">DA DATA EMISSIONE </label>
    <input v-focus required type="date" class="form-control" v-model="coupon.start">        
  </div>

  <div class="form-group col-md-6">
    <label for="formGroupExampleInput4">A DATA EMISSIONE</label>
    <input required type="date" class="form-control" v-model="coupon.end">        
  </div>

  
      
      <button  type="button" @click="$emit('close')" class="btn btn-secondary ml-4 mr-4">
        <i class="fas fa-reply mr-3" aria-hidden="true"></i>
         ANNULLA       
      </button>
      <button  type="submit" class="btn btn-primary ">
        <i   class="fas fa-binoculars mr-3" aria-hidden="true"></i>
         CERCA        
      </button>

      
</form>
</div>
</div> 
    




</div>


</div>
</template>
<script>


import api                        from '@/api'

import { mapGetters }             from 'vuex';
import modalMessage               from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm               from '@/components/modalDialog/ModalConfirm.vue'

import { v4 as uuidv4 }           from 'uuid'
export default {

    
    
    components : {modalConfirm,modalMessage},
  
 data () {
    return {
    

    uuid                 : '',      
    coupon               : {start:''},
   
   

    }
  },
  directives: 
    {
      focus: {
      
        inserted: function (el) {
          
          el.focus()
          el.select()
          }
           
       
      }
    },
  computed: {
    ...mapGetters(['company','storeId']) 
  },

  
mounted()
{

 this.uuid          = uuidv4()  
 this.initCoupon()
    
},  
created()
{ 
    
    
},
methods :
{
  
initCoupon()
{

  const today           = new Date().toISOString().slice(0,10)  
  this.coupon.start     = today
  this.coupon.end       = today
  this.coupon.companyId = this.company.Id
  
    
},

async submit() 
  {
      
       const confirmed=  await this.$refs.confirmModal.show(
          'SI DESIDERA EFFETTUARE LA RICERCA ?',
          { title: 'CONFERMA ' },1
        )

        if (!confirmed) return  
        this.$refs.confirmModal.close()

     
      const uuid     = this.uuid  
      const sp       = 'spCouponResearch'
      const payload  = {sp,...this.coupon,uuid}    
      this.$refs.msgModal.show('',{'spinner' : true,'title':'ELABORAZIONE IN CORSO ...'},1)  
     try{

       const res = await api.post(payload)


          if (res.status !== 200) 
          {
              throw new Error(res.data ||  res)
          }


          const data = res.data.recordsets[0]    
          this.$emit('update',data)
         
          
         
    }
    catch(err){
           
            const msg = err.message             
            this.$refs.msgModal.show(msg,{title:'ATTENZIONE !'},3)

    }
  
      
	},



}

}

</script>
<style scoped>


h4 {
  font-family: "Roboto Condensed";
  font-size: 20px;
}

</style>
